import { CheckCircleIcon, ClockIcon } from '@heroicons/react/24/outline';
import { Trans, useTranslation } from 'react-i18next';
import RetentionOfferShell from '../RetentionOfferShell.component';
import { tExtensionOfferModalProps } from '../RetentionOfferModal.types';

const COMMITMENTS = [
  'commitment1',
  'commitment2',
  'commitment3',
  'commitment4',
] as const;

/**
 * The extension offer for a customer leaving over technical problems: extra days
 * while the team works the case. Every term comes from the offer the server
 * resolved — the modal only frames it.
 */
export default function TechnicalProblemsOfferModal(
  props: tExtensionOfferModalProps,
) {
  const {
    isOpen,
    offer,
    onAcceptOffer,
    onFinalizeSubscription,
    onBack,
    onClose,
    isLoadingOfferAcceptance,
    isLoadingFinalization,
  } = props;
  const { t } = useTranslation('settings/SubscriptionManager');
  const days = { days: offer.durationDays };

  return (
    <RetentionOfferShell
      isOpen={isOpen}
      heading={t('cancelSubscription.retentionOfferTechnical.heading')}
      intro={t('cancelSubscription.retentionOfferTechnical.offerTitle')}
      cardIcon={ClockIcon}
      cardTitle={t('cancelSubscription.retentionOfferTechnical.offer', days)}
      cardTerm={t('cancelSubscription.retentionOfferTechnical.noExtraCost')}
      // Testimonials return only with real, approved customer quotes (PD8, 2026-09-25).
      onBack={onBack}
      onDecline={onFinalizeSubscription}
      onAccept={onAcceptOffer}
      acceptLabel={t(
        'cancelSubscription.retentionOfferTechnical.acceptButton',
        days,
      )}
      declineLabel={t(
        'cancelSubscription.retentionOfferTechnical.declineButton',
      )}
      onClose={onClose}
      isLoadingAccept={isLoadingOfferAcceptance}
      isLoadingDecline={isLoadingFinalization}
      testIdPrefix="technical-problems-offer"
    >
      <p className="text-base font-semibold text-neutral-800">
        {t('cancelSubscription.retentionOfferTechnical.commitmentsTitle')}
      </p>
      <ul className="flex flex-col gap-2">
        {COMMITMENTS.map((key) => (
          <li
            key={key}
            className="flex items-start gap-2 text-base text-neutral-700"
          >
            <CheckCircleIcon
              aria-hidden="true"
              className="mt-0.5 h-5 w-5 flex-shrink-0 text-success"
            />
            <span>
              <Trans
                i18nKey={`settings/SubscriptionManager:cancelSubscription.retentionOfferTechnical.${key}`}
                values={days}
                components={{ bold: <strong /> }}
              />
            </span>
          </li>
        ))}
      </ul>
    </RetentionOfferShell>
  );
}
